import axios from 'api/axios'
import { useCallback, useEffect, useState } from 'react'

// /**
//  * @module FetchHooks
//  */
// /**
//  * @module Efacturs
//  */

/**
 *
 * @param {Object} prop
 * @param {Object} props.filters
 * @param {string} props.filters.documentType
 * @param {string} props.filters.grupoBalance
 * @param {string} props.filters.organizacionCompras
 */

const useFetchEfacturas = ({ documentType, grupoBalance, organizacionCompras }) => {
  const [response, setResponse] = useState([])
  const [error, setError] = useState()
  const [loading, setLoading] = useState(false)

  const fetchData = useCallback(() => {
    setLoading(true)
    const params = new URLSearchParams({ idioma: '01' })
    if (documentType) params.set('tipo_documento', documentType)
    if (grupoBalance) params.set('grupo_balance', grupoBalance)
    if (organizacionCompras) params.set('organizacion_compras', organizacionCompras)

    axios
      .get(`/efactura/compras/?${params.toString()}`)
      .then((request_response) => {
        setResponse(request_response.data)
        setError(null)
      })
      .catch((request_error) => setError(request_error))
      .finally(() => setLoading(false))
  }, [documentType, grupoBalance, organizacionCompras])

  useEffect(() => {
    if (!loading) {
      fetchData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentType, grupoBalance, organizacionCompras])

  return { response, error, loading, reFetch: fetchData }
}

export default useFetchEfacturas
